import { ListItemText } from '@razz-team/ui-web';
import { StatementRequest } from '../../../api/accounts';
import { useTranslation } from 'react-i18next';

export type StatementType = StatementRequest['type'];

export function StatementTitle({ type }: { type: StatementType }) {
  const { t } = useTranslation();
  switch (type) {
    case 'csv':
      return t('Account statement (CSV)');
    case 'balance':
      return t('Balance statement');
    case 'avg_balance':
      return t('Average balance statement');
    case 'transactions':
      return t('Transactions statement');
    case 'balance_and_transactions':
      return t('Balance and transactions statement');
  }
}

export function StatementSecondaryTitle({ type }: { type: StatementType }) {
  const { t } = useTranslation();
  switch (type) {
    case 'csv':
      return t('Movement of funds in the account');
    case 'balance':
      return t('Proof of balance and availablity of funds');
    case 'avg_balance':
      return t('Proof of average and current balance');
    case 'transactions':
      return t('Proof of transactions');
    case 'balance_and_transactions':
      return t('Proof of balance, availablity of funds and transactions');
  }
}

export function StatementListItem({ type }: { type: StatementType }) {
  return (
    <ListItemText
      primary={<StatementTitle type={type} />}
      secondary={<StatementSecondaryTitle type={type} />}
    />
  );
}
